import { videos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function LatestSection() {
  const latestVideos = videos.filter((v) => v.isNew).slice(0, 6);

  return (
    <section className="py-16 bg-background-50">
      <div className="container-page">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-2">刚刚更新的热门内容，抢先观看</p>
          </div>
          <a href="/category/dianshiju" className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {latestVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}